var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('van-nav-bar',{attrs:{"title":"","left-arrow":""},on:{"click-left":function($event){return _vm.$router.back(-1)}}}),_vm._v(" "),_c('div',{staticClass:"setting"},[_c('div',[_vm._v(_vm._s(_vm.$t('NoData.buy')))]),_c('div',[_vm._v(_vm._s(_vm.$t('NoData.sale')))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58899731","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Shop/NoData.vue
// module id = null
// module chunks = 